function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/onboarding-5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "3.515625e-05 3.47826087e-05 45 3.47826087e-05 45 48 3.515625e-05 48"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "3.515625e-05 3.47826087e-05 45 3.47826087e-05 45 44.5217739 3.515625e-05 44.5217739"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "3.515625e-05 3.47826087e-05 45 3.47826087e-05 45 44.5217739 3.515625e-05 44.5217739"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-743.000000, -969.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/onboarding-5",
  transform: "translate(743.000000, 969.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-28"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5000352,48.0000348 L22.5000352,48.0000348 C10.073707,48.0000348 3.515625e-05,38.0334261 3.515625e-05,25.7391652 L3.515625e-05,4.17394783 C3.515625e-05,1.86890435 1.88898047,3.47826087e-05 4.21878516,3.47826087e-05 L40.7812852,3.47826087e-05 C43.1110898,3.47826087e-05 45.0000352,1.86890435 45.0000352,4.17394783 L45.0000352,25.7391652 C45.0000352,38.0334261 34.9263633,48.0000348 22.5000352,48.0000348",
  id: "Fill-1",
  fill: "#AD8D07",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5000352,44.5217739 L22.5000352,44.5217739 C10.073707,44.5217739 3.515625e-05,34.5551652 3.515625e-05,22.2609043 L3.515625e-05,4.17394783 C3.515625e-05,1.86890435 1.88898047,3.47826087e-05 4.21878516,3.47826087e-05 L40.7812852,3.47826087e-05 C43.1110898,3.47826087e-05 45.0000352,1.86890435 45.0000352,4.17394783 L45.0000352,22.2609043 C45.0000352,34.5551652 34.9263633,44.5217739 22.5000352,44.5217739",
  id: "Fill-4",
  fill: "#FFDC4A",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7812852,3.47826087e-05 L4.21878516,3.47826087e-05 C1.88898047,3.47826087e-05 3.515625e-05,1.86890435 3.515625e-05,4.17394783 L3.515625e-05,22.2609043 C3.515625e-05,34.5551652 10.0733555,44.5217739 22.5000352,44.5217739 L22.5000352,44.5217739 C34.9263633,44.5217739 45.0000352,34.5551652 45.0000352,22.2609043 L45.0000352,4.17394783 C45.0000352,1.86890435 43.1110898,3.47826087e-05 40.7812852,3.47826087e-05 M40.7812852,4.17394783 L40.7812852,22.2609043 C40.7812852,32.2341217 32.5803867,40.3478609 22.5000352,40.3478609 C12.4196836,40.3478609 4.21878516,32.2341217 4.21878516,22.2609043 L4.21878516,4.17394783 L40.7812852,4.17394783",
  id: "Fill-7",
  fill: "#D3AB05",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.4390625,15.8329391 C17.5478906,11.3254609 9.83496094,9.92650435 8.21179687,12.7080696 C7.31003906,14.253113 8.476875,16.7630261 11.0453906,19.4621565 C13.1002734,21.6218087 16.0530469,23.9025043 19.5609375,25.9059826 C27.4521094,30.4138087 35.1650391,31.8127652 36.7882031,29.0312 C38.4113672,26.2496348 33.3302344,20.3404174 25.4390625,15.8329391 Z",
  id: "Stroke-10",
  stroke: "#D3AB05",
  strokeWidth: 1.73913043
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4390625,25.9061217 C33.3302344,21.3986435 38.4113672,15.4894261 36.7882031,12.7078609 C35.1650391,9.92629565 27.4521094,11.3256 19.5609375,15.8330783 C11.6697656,20.3405565 6.58863281,26.2494261 8.21179687,29.0309913 C9.83496094,31.8129043 17.5478906,30.4136 25.4390625,25.9061217 Z",
  id: "Stroke-12",
  stroke: "#D3AB05",
  strokeWidth: 1.73913043
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0133203,20.8696 C25.0133203,19.4963826 23.8879688,18.3829913 22.5,18.3829913 C21.1120313,18.3829913 19.9866797,19.4963826 19.9866797,20.8696 C19.9866797,22.2428174 21.1120313,23.3562087 22.5,23.3562087 C23.8879688,23.3562087 25.0133203,22.2428174 25.0133203,20.8696",
  id: "Fill-14",
  fill: "#AD8D07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.573125,11.2775652 C13.573125,10.3415652 12.8060156,9.5826087 11.8599609,9.5826087 C10.9142578,9.5826087 10.1471484,10.3415652 10.1471484,11.2775652 C10.1471484,12.2135652 10.9142578,12.9725217 11.8599609,12.9725217 C12.8060156,12.9725217 13.573125,12.2135652 13.573125,11.2775652",
  id: "Fill-16",
  fill: "#AD8D07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.3194141,17.5165217 C37.3194141,16.5805217 36.5523047,15.8215652 35.60625,15.8215652 C34.6601953,15.8215652 33.8934375,16.5805217 33.8934375,17.5165217 C33.8934375,18.4525217 34.6601953,19.2114783 35.60625,19.2114783 C36.5523047,19.2114783 37.3194141,18.4525217 37.3194141,17.5165217",
  id: "Fill-18",
  fill: "#AD8D07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.825457,20.8696 C30.825457,13.0939478 27.0978398,6.79029565 22.5001055,6.79029565 C17.9020195,6.79029565 14.1747539,13.0939478 14.1747539,20.8696 C14.1747539,28.6452522 17.9020195,34.9485565 22.5001055,34.9485565 C27.0978398,34.9485565 30.825457,28.6452522 30.825457,20.8696 Z",
  id: "Stroke-20",
  stroke: "#AD8D07",
  strokeWidth: 1.73913043
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.04525,19.4620174 C13.1004844,21.6216696 16.0529062,23.9023652 19.5607969,25.9061913",
  id: "Stroke-22",
  stroke: "#D3AB05",
  strokeWidth: 1.73913043
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.7882734,12.7079304 C35.1651094,9.92636522 27.4518281,11.3253217 19.5610078,15.8328",
  id: "Stroke-24",
  stroke: "#D3AB05",
  strokeWidth: 1.73913043
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2130586,34.9485913 C24.2130586,34.0125913 23.4459492,33.2536348 22.4998945,33.2536348 C21.5538398,33.2536348 20.787082,34.0125913 20.787082,34.9485913 C20.787082,35.8845913 21.5538398,36.6435478 22.4998945,36.6435478 C23.4459492,36.6435478 24.2130586,35.8845913 24.2130586,34.9485913",
  id: "Fill-26",
  fill: "#D3AB05"
})))));

var SvgOnboarding5 = function SvgOnboarding5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnboarding5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onboarding-5.466bcaad.svg";
export { ForwardRef as ReactComponent };